import api from './api';
export interface TemplateRules {
  permissions: Record<string, boolean>;
  ownerEditablePermissions: string[];
}
export interface PermissionTemplate {
  key: string;
  name: string;
  activeVersion: string;
  revision: string;
}
/** Server-registered template boundary; administrators cannot add templates. */
export interface TemplateDefinition {
  key: string;
  name: string;
  initialRules: TemplateRules;
  grantablePermissions: string[];
  ownerEditableScope: string[];
}
export interface TemplateVersion {
  templateKey: string;
  version: string;
  state: 'draft' | 'published';
  rules: TemplateRules;
  revision: string;
}
export interface TemplatePage {
  templates: PermissionTemplate[];
  definitions: TemplateDefinition[];
  nextKey: string;
}
const path = '/api/v1/admin/tutti-permissions/templates';
export const defaultGuestTemplateKey = 'room.guest.default';
export const publicRoomGuestTemplateKey = 'room.public.guest.default';
export const permissionTemplatesApi = {
  list: () => api.get<unknown, TemplatePage>(path),
  versions: (templateKey: string, afterVersion = '0') =>
    api.get<unknown, { versions: TemplateVersion[]; nextVersion: string }>(
      `${path}/versions`,
      {
        params: {
          templateKey,
          afterVersion,
          pageSize: 50,
        },
      },
    ),
  save: (
    templateKey: string,
    rules: TemplateRules,
    version = '0',
    expectedRevision = '0',
  ) =>
    api.post<unknown, { version: TemplateVersion }>(`${path}/draft`, {
      templateKey,
      rules,
      version,
      expectedRevision,
    }),
  publish: (version: TemplateVersion) =>
    api.post(`${path}/publish`, {
      templateKey: version.templateKey,
      version: version.version,
      expectedRevision: version.revision,
    }),
  activate: (version: TemplateVersion, template: PermissionTemplate) =>
    api.post(`${path}/activate`, {
      templateKey: version.templateKey,
      version: version.version,
      expectedRevision: template.revision,
    }),
};
